import Map from "../map/map"

export const ContactForm = () => {
    const data = [
        {
            icon: '/call.svg',
            heading: 'Call',
            desc: '084524145547',
        },
        {
            icon: '/email.svg',
            heading: 'Email',
            desc: 'arshakir132@gmail.com',
        },
        {
            icon: '/location.svg',
            heading: 'Location',
            desc: 'Texas, USA',
        },
    ]
    const handleSubmit = () => {

    }
    return (
        <div className="relative max-w-7xl mx-auto mt-20 px-6">
            <div className="relative z-20 p-10 sm:p-16 rounded-[46px] bg-gradient-to-b from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0.05)] border border-t-0 border-l-0 border-b-[rgba(0,170,108,0.5)] border-r-[rgba(0,170,108,0.5)] mt-20">
                <div className="flex flex-col-reverse lg:flex-row gap-20">
                    <div className="lg:w-[55%]">
                        <Map/>
                    </div>
                    <form onSubmit={handleSubmit} className="flex-1 flex flex-col gap-6">
                        <input type="text" placeholder="Name" className="bg-[#1E3954] rounded-[20px] px-6 py-5 font-lato text-base text-white focus:outline-none" />
                        <input type="email" placeholder="Email Adress" className="bg-[#1E3954] rounded-[20px] px-6 py-5 font-lato text-base text-white focus:outline-none" />
                        <textarea name="" id="" placeholder="Message" className="bg-[#1E3954] rounded-[20px] px-6 py-5 font-lato text-base text-white focus:outline-none"></textarea>
                        <button type="button" className="mt-2 bg-[#04D1D6] rounded-[20px] px-6 py-4 font-lato text-xl font-medium text-black focus:outline-none">Send now</button>
                    </form>
                </div>
                <div className="flex lg:justify-center gap-24 pt-16 flex-wrap">
                    {data.map((item, index) => {
                        return (
                            <div className="flex items-center gap-4" key={index}>
                                <div className="h-[42px] w-[42px]">
                                    <img src={item.icon} alt="" className="w-full" />
                                </div>
                                <div className="flex flex-col gap-[2px] font-lato text-white">
                                    <p className="text-xl font-medium">{item.heading}</p>
                                    <p className="font-normal">{item.desc}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <img src="/circle2.png" alt="" className="absolute -left-[24%] -bottom-16 h-[600px]"/>
        </div>
    )
}
